import { createFileRoute } from '@tanstack/react-router';

import { BCPAllPlansLiveWorkspace } from '@/features/bcp/components/BCPAllPlansLiveWorkspace';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/bcp/plans/')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.continuityPlans'),
  }),
  component: ContinuityPlansIndexPage,
});

function ContinuityPlansIndexPage() {
  return <BCPAllPlansLiveWorkspace />;
}
